<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Card</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <h1>Global Card</h1>
  <div class="flex u-pt-10 u-pb-40 u-pl-0 u-list-style-none">
    <div
      class="flex-col flex-col-12 flex-col-sm-6 flex-col-md-6 flex-col-lg-4 flex-col-xl-3 flex-col-xxl-2 u-mt-10 u-mb-10">
      <maced-global-card cardId="sampleCard3" cardName="sampleCardName3">
        <maced-button buttonId="Login" label="Login" color="primary">
        </maced-button>
        <p class="c-card__body-content">Don't have an account yet?</p>
        <maced-button buttonId="CreateAccount" label="Create Account" color="secondary">
        </maced-button>
      </maced-global-card>
    </div>
  </div>
  <h1>Create Card</h1>
  <form [formGroup]="createCardForm">
    <div class="flex u-pt-10 u-pb-40 u-pl-0 u-list-style-none">
      <div
        class="flex-col flex-col-12 flex-col-sm-6 flex-col-md-6 flex-col-lg-4 flex-col-xl-3 flex-col-xxl-2 u-mt-10 u-mb-10">
        <maced-create-card id="dummyId2" name="createCard" [cardImageWidthLarge] = "42" [cardImageHeightLarge]="49" value="dummyValue1" cardTitle="Dummy Title"
          imageUrl="../assets/default/images/add-book.svg" formControlName="cardValue" ariaLabel="dummyAriaLabel2">
        </maced-create-card>
      </div>
      <div
        class="flex-col flex-col-12 flex-col-sm-6 flex-col-md-6 flex-col-lg-4 flex-col-xl-3 flex-col-xxl-2 u-mt-10 u-mb-10">
        <maced-create-card id="dummyId3" name="createCard" value="dummyValue2" cardTitle="Another Dummy Title" [cardImageWidthLarge]="42" [cardImageHeightLarge]="49"
          imageUrl="../assets/default/images/add-book.svg" formControlName="cardValue" ariaLabel="dummyAriaLabel3">
        </maced-create-card>
      </div>
    </div>
  </form>
  Selected:- {{ createCardForm.value.cardValue }}
  <br>
  <h1>Enhanced Card with Radio button for future requirements</h1>
  <form [formGroup]="enhancedCardForm">
    <div class="flex u-pt-10 u-pb-40 u-pl-0 u-list-style-none">
      <div
        class="flex-col flex-col-12 flex-col-sm-6 flex-col-md-6 flex-col-lg-4 flex-col-xl-3 flex-col-xxl-2 u-mt-10 u-mb-10">
        <maced-enhanced-card id="dummyId4" name="enhancedCard" value="dummyValue1" cardBodyId="cardBodyId" cardLabelId="cardLabelId"
          imageUrl="../assets/default/images/yx8h6prm3pfpcppq53wa.png" cardTitle="Normal card"  [cardImageWidthLarge] = 215 [cardImageHeightLarge] = 125
          subtitle="Share It!, Level 5" [list]="list" buttonName="Go To Button" buttonUrl="/button" enhancedCardLabel="Dummy Enhanced Card"
          formControlName="cardValue" ariaLabel="dummyAriaLabel4">
        </maced-enhanced-card>
      </div>
      <div
        class="flex-col flex-col-12 flex-col-sm-6 flex-col-md-6 flex-col-lg-4 flex-col-xl-3 flex-col-xxl-2 u-mt-10 u-mb-10">
        <maced-enhanced-card id="dummyId5" name="enhancedCard" value="dummyValue2" cardBodyId="cardBodyId1" cardLabelId="cardLabelId1"
          imageUrl="../assets/default/images/yx8h6prm3pfpcppq53wa.png" cardTitle="Normal card"  [cardImageWidthLarge] = 215 [cardImageHeightLarge] = 125
          subtitle="Share It!, Level 5" [list]="list" buttonName="Go To Button" buttonUrl="/button"enhancedCardLabel="Dummy Enhanced Card"
          formControlName="cardValue" ariaLabel="dummyAriaLabel5">
        </maced-enhanced-card>
      </div>
    </div>
  </form>
  Selected:- {{ enhancedCardForm.value.cardValue }}
  <br>
  <br>
  <h1>Enhanced Card with Link</h1>
  <div class="flex u-pt-10 u-pb-40 u-pl-0 u-list-style-none">
    <div
      class="flex-col flex-col-12 flex-col-sm-6 flex-col-md-6 flex-col-lg-4 flex-col-xl-3 flex-col-xxl-2 u-mt-10 u-mb-10">
      <maced-enhanced-card [id]="dummyId6" name="enhancedCard" cardBodyId="cardBodyId2" cardLabelId="cardLabelId2"
        imageUrl="../assets/default/images/yx8h6prm3pfpcppq53wa.png" cardTitle="Card With Link"  [cardImageWidthLarge] = 215 [cardImageHeightLarge] = 125
        subtitle="Share It!, Level 5" [list]="list" targetUrl="/button" ariaLabel="dummyAriaLabel5" enhancedCardLabel="Dummy Enhanced Card">
      </maced-enhanced-card>
    </div>
    <div
      class="flex-col flex-col-12 flex-col-sm-6 flex-col-md-6 flex-col-lg-4 flex-col-xl-3 flex-col-xxl-2 u-mt-10 u-mb-10">
      <maced-enhanced-card [id]="dummyId7" name="enhancedCard2" cardBodyId="cardBodyId3" cardLabelId="cardLabelId3"
        imageUrl="../assets/default/images/yx8h6prm3pfpcppq53wa.png" cardTitle="Card With Link" [cardImageWidthLarge] = 215 [cardImageHeightLarge] = 125
        subtitle="Share It!, Level 5" [list]="list" targetUrl="/toast" ariaLabel="dummyAriaLabel6" enhancedCardLabel="Dummy Enhanced Card">
      </maced-enhanced-card>
    </div>
  </div>
</div>